// src/pages/PrivacyPolicyPage.js - 개인정보처리방침 페이지

import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from '../context/AppContext';
import './PrivacyPolicyPage.scss';

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();
  const { isLoggedIn } = useAppContext();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleBack = () => {
    const targetPath = isLoggedIn ? '/' : '/login';
    navigate(targetPath, { replace: true });
    window.scrollTo(0, 0);
  };

  return (
    <div className="privacy-page">
      {/* Header */}
      <header className="privacy-header">
        <div className="container">
          <div className="privacy-header-content">
            <button 
              className="privacy-back-button"
              onClick={handleBack}
            >
              <FontAwesomeIcon icon={faChevronLeft} />
            </button>
            <div className="logo">
              <Link to="/">
                <h1>ReOpsAI</h1>
              </Link>
            </div>
          </div>
        </div>
      </header>

      {/* Content */}
      <section className="privacy-content-section">
        <div className="container">
          <div className="privacy-wrapper">
            <h1 className="privacy-title">ReOpsAI 개인정보/데이터 처리방침</h1>
            <p className="privacy-updated-date">수정일자: 2025년 11월 19일 | 시행일자: 2025년 11월 17일</p>
            
            <div className="privacy-body">
              <section className="privacy-section">
                <h2>제1조 (개인정보의 처리 목적)</h2>
                <p>
                  주식회사 피엑스디(이하 "회사"라고 합니다)가 만들고 서비스하는
                  ReOpsAI(<a href="http://www.reopsai.com">www.reopsai.com</a>, 이하 "리옵스에이아이"라 합니다)은 다음의 목적을 위하여 개인정보를
                  처리하고 있으며, 다음의 목적 이외의 용도로는 이용하지 않습니다.
                </p>
                <div className="privacy-subsection">
                  <p>
                    <strong>1. 수집하는 항목</strong>
                  </p>
                  <div className="privacy-info-box">
                    <p>
                      서비스 이용 기록, 접속 로그, 쿠키, 접속 IP 정보, 사용자 입력 데이터(프롬프트), 생성된 결과물, 마우스 클릭 및 스크롤 등 사용자 행동 패턴(Session Data), 서비스 이용 과정에서 사용자가 업로드한 설문 응답자 데이터(단, 저장 시 비식별화 처리됨)
                    </p>
                  </div>
                  <p>
                    <strong>2. 수집 목적</strong>
                  </p>
                  <div className="privacy-info-box">
                    <p>
                      서비스 제공 및 운영, AI 모델 및 서비스 품질 개선(RAG 성능 최적화 등), 오류 분석 및 버그 수정, 신규 서비스 개발
                    </p>
                  </div>
                  <p>
                    <strong>3. 처리 목적</strong>
                  </p>
                  <ol>
                    <li>
                      <strong>고객 가입의사 확인, 고객에 대한 서비스 제공에 따른 본인
                        식별·인증, 회원자격 유지·관리, 서비스 공급 등에 따른 금액
                        결제, 서비스의 공급 등. 또한 베타 서비스 기간 동안 발생하는 시스템 오류 수정, 버그 해결 및 서비스 안정화를 위하여 관리자가 데이터베이스에 접근하여 데이터를 열람하거나 분석할 수 있습니다.</strong>
                    </li>
                    <li><strong>개인식별이 불가능한 정보들의 통계 용도</strong></li>
                    <li>
                      <strong>회원이 이미 공개적으로 리옵스에이아이를 이용하여 진단/분석을
                        진행하였거나 진행하고 있는 경우 해당 회원이 리옵스에이아이
                        이용자임을 대외적으로 광고 또는 홍보하기 위한 용도</strong>
                    </li>
                  </ol>
                </div>
              </section>

              <section className="privacy-section">
                <h2>제2조 (개인정보의 처리 및 보유 기간)</h2>
                <div className="privacy-subsection">
                  <p>
                    <strong>1.</strong> 회사는 정보주체로부터 개인정보를 수집할 때
                    동의 받은 개인정보 보유·이용기간 또는 법령에 따른 개인정보
                    보유·이용기간 내에서 개인정보를 처리·보유합니다.
                  </p>
                  <p>
                    <strong>2.</strong> 원칙적으로, 개인정보 수집 및 이용목적이 달성된
                    후에는 해당 정보를 지체 없이 파기합니다. 단, 관계법령의 규정에
                    의하여 보존할 필요가 있는 경우 회사는 아래와 같이 관계법령에서
                    정한 일정한 기간 동안 회원정보를 보관합니다.
                  </p>
                  <div className="privacy-info-box">
                    <h3>법령에 따른 보관 기간</h3>
                    <ul>
                      <li>
                        <strong>표시·광고에 관한 기록 : 6개월</strong>
                        (전자상거래등에서의 소비자보호에 관한 법률)
                      </li>
                      <li>
                        <strong>계약 또는 청약철회 등에 관한 기록 : 5년</strong>
                        (전자상거래등에서의 소비자보호에 관한 법률)
                      </li>
                      <li>
                        <strong>대금결제 및 재화 등의 공급에 관한 기록 : 5년</strong>
                        (전자상거래등에서의 소비자보호에 관한 법률)
                      </li>
                      <li>
                        <strong>소비자의 불만 또는 분쟁처리에 관한 기록 : 3년</strong>
                        (전자상거래등에서의 소비자보호에 관한 법률)
                      </li>
                      <li>
                        <strong>신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년</strong>
                        (신용정보의 이용 및 보호에 관한 법률)
                      </li>
                      <li>
                        <strong>통신사실확인자료 제공 : 3개월</strong>
                        (통신비밀보호법)
                      </li>
                    </ul>
                  </div>
                  <p>
                    <strong>3.</strong> 회사는 다음의 목적을 위해 적법한 근거를 갖추어
                    개인정보를 처리합니다. 회사가 처리하는 개인정보는 다음의 목적
                    이외의 용도로는 사용되지 않으며, 이용 목적이 변경되는 경우에는
                    「개인정보 보호법」 제18조에 따라 회원에게 사전동의를 구하는 등
                    적법한 근거를 마련할 예정입니다.
                  </p>
                  <div className="privacy-highlight">
                    <p>
                      <strong>회원 가입 및 관리 </strong><br />
                      구글 ID, 이메일, 이름, 프로필 사진
                    </p>
                  </div>
                </div>
              </section>

              <section className="privacy-section">
                <h2>제3조 (개인정보의 제3자 제공)</h2>
                <div className="privacy-subsection">
                  <p>
                    <strong>1.</strong> 회사는 정보주체의 별도 동의, 법률의 특별한
                    규정 등 개인정보 보호법 제17조에 해당하는 경우 외에는 개인정보를
                    제3자에게 제공하지 않습니다.
                  </p>
                  <p>
                    <strong>2.</strong> 리옵스에이아이에서 Google API 로부터 받은 정보를
                    사용하거나 다른 앱으로 전송할 때는 [Google API 서비스 사용자
                    데이터 정책]과 제한된 사용 요구사항을 준수합니다.
                  </p>
                  <p>
                    <strong>3.</strong> 개인정보보호법 제59조(금지행위)에 따라 회사의
                    서비스 제공을 위하여 개인정보를 취급하거나 취급하였던 회사의
                    관계자는 다음 각 호의 행위를 하지 않습니다.
                  </p>
                  <div className="privacy-list-item">
                    <p>
                      가. 거짓이나 그 밖의 부정한 수단이나 방법으로 개인정보를
                      취득하거나 처리에 관한 동의를 받는 행위
                    </p>
                    <p>
                      나. 업무상 알게 된 개인정보를 누설하거나 권한 없이 다른 사람이
                      이용하도록 제공하는 행위
                    </p>
                    <p>
                      다. 정당한 권한 없이 또는 허용된 권한을 초과하여 다른 사람의
                      개인정보를 훼손, 멸실, 변경, 위조 또는 유출하는 행위
                    </p>
                  </div>
                </div>
              </section>

              <section className="privacy-section">
                <h2>제4조 (개인정보처리 위탁)</h2>
                <div className="privacy-subsection">
                  <p>
                    <strong>1.</strong> 회사는 원활한 개인정보 업무처리를 위하여
                    다음과 같이 개인정보 처리업무를 위탁하고 있습니다.
                  </p>
                  <div className="privacy-table-wrapper">
                    <table className="privacy-table">
                      <thead>
                        <tr>
                          <th>수탁업체</th>
                          <th>위탁업무 내용</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>AWS</td>
                          <td>서버 및 데이터베이스</td>
                        </tr>
                        <tr>
                          <td>Supabase</td>
                          <td>서버 및 데이터베이스</td>
                        </tr>
                        <tr>
                          <td>Google LLC</td>
                          <td>웹로그 분석 (Google Analytics)</td>
                        </tr>
                        <tr>
                          <td>Microsoft Corporation</td>
                          <td>사용자 행동 분석 및 세션 녹화 (Clarity)</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <p>
                    <strong>2.</strong> 회사는 위탁계약 체결 시 개인정보 보호법
                    제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지,
                    기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독,
                    손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가
                    개인정보를 안전하게 처리하는지를 감독하고 있습니다.
                  </p>
                  <p>
                    <strong>3.</strong> 위탁업무의 내용이나 수탁자가 변경될 경우에는
                    지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.
                  </p>
                </div>
              </section>

              <section className="privacy-section">
                <h2>제5조 (제3자 AI 모델 활용)</h2>
                <div className="privacy-subsection">
                  <p>
                    <strong>1.</strong> 회사는 일부 기능에서 더 나은 서비스를 제공하기
                    위해 제3자 AI 모델을 사용합니다.
                  </p>
                  <div className="privacy-info-box">
                    <h4>진단/분석과 리포트 작성</h4>
                    <ul>
                      <li>
                        리옵스에이아이는 사용자가 요청한 진단/분석을 위해 OpenAI, Inc., Google gemini의 LLM API를 이용하여 진단/분석 기능을 제공
                      </li>
                      <li>
                        사용자가 입력한 데이터는 LLM 모델에 전송되며 중간 산출물을
                        생성하는 목적으로 사용됨
                      </li>
                      <li>
                        생성된 중간 산출물은 리옵스에이아이 플랫폼에서 사용할 수 있음
                      </li>
                      <li>
                        진단/분석과 리포트 작성 기능을 제공하기 위해 리옵스에이아이는 OpenAI, Inc., Google gemini의 API를 이용하며, 사용자가 입력한 원본 데이터 또는 AI가 생성한
                        콘텐츠는 해당 서비스 제공자의 AI 학습에 사용되지 않음
                      </li>
                    </ul>
                  </div>
                  <p>
                    <strong>2.</strong> 회사는 사용자 데이터의 책임 있고 윤리적인
                    사용을 약속하며, 데이터 처리는 투명하게 이루어집니다. 사용자
                    프라이버시와 데이터 보안이 최우선이며, 모든 데이터 처리는 관련
                    법률 및 규정을 준수합니다.
                  </p>
                  <p>
                    <strong>3.</strong> 회사는 AI 모델 사용과 관련된 모든 절차에서
                    투명성을 유지합니다. 사용자는 언제든지 자신의 데이터가 어떻게
                    사용되고 있는지 확인할 수 있으며, 필요한 경우 추가 정보를 요청할
                    수 있습니다.
                  </p>
                </div>
              </section>

              <section className="privacy-section">
                <h2>제6조 (공유 페이지 서비스)</h2>
                <div className="privacy-subsection">
                  <p>
                    회사는 사용자가 리옵스에이아이 서비스에서 생성한 진단/분석 결과를 외부에 공유할 수 있는 기능을 제공합니다. 공유 서비스 사용시, 관련 데이터가 리옵스에이아이 서버로 전송됩니다. 이를 위해 회사는 다음 각 호의 사항을 준수합니다:
                  </p>
                  <p>
                    <strong>1.</strong> 사용자가 리옵스에이아이 서비스에서 생성한 진단/분석 결과를 서버에 안전하게 저장하고 고유한 URL 주소와 암호키를
                      사용하여 사용자의 데이터를 보호합니다.
                  </p>
                  <p>
                    <strong>2.</strong> 전송되는 데이터는 사용자가 진단/분석 요청한
                      데이터와 진단/분석 데이터, 생성한 리포트 등이 포함될 수 있습니다.
                  </p>
                  <p>
                    <strong>3.</strong> 회사는 데이터 공유 시 사용자의 개인정보
                      보호를 위해 관련 법률 및 규정을 준수하며, 데이터 보안을
                      최우선으로 합니다.
                  </p>
                  <p>
                    <strong>4.</strong> 회사는 사용자 데이터의 책임 있고 윤리적인
                      사용을 약속하며, 데이터 처리는 투명하게 이루어집니다. 사용자는
                      언제든지 자신의 데이터가 어떻게 사용되고 있는지 확인할 수
                      있으며, 필요한 경우 추가 정보를 요청할 수 있습니다.
                  </p>
                </div>
              </section>

              <section className="privacy-section">
                <h2>제7조 (권리)</h2>
                <div className="privacy-subsection">
                  <p>
                    <strong>1.</strong> 이용자는 개인정보주체로서 다음과 같은 권리를
                    행사할 수 있으며, 정보주체는 리옵스에이아이에 대해 언제든지 다음 각
                    호의 개인정보 보호 관련 권리를 행사할 수 있습니다.
                  </p>
                  <div className="privacy-list-item">
                    <p>가. 개인정보 열람요구</p>
                    <p>나. 오류 등이 있을 경우 정정 요구</p>
                    <p>다. 삭제요구</p>
                    <p>라. 처리정지 요구</p>
                  </div>
                  <p>
                    <strong>2.</strong> 제1항에 따른 권리 행사는 회사에 대해 서면,
                    전자우편, 고객지원 등을 통하여 하실 수 있으며 회사는 이에 대해
                    지체없이 조치하겠습니다.
                  </p>
                  <p>
                    <strong>3.</strong> 이용자가 개인정보의 오류 등에 대한 정정 또는
                    삭제를 요구한 경우에는 회사는 정정 또는 삭제를 완료할 때까지 당해
                    개인정보를 이용하거나 제공하지 않습니다.
                  </p>
                  <p>
                    <strong>4.</strong> 만 14세 미만 아동의 경우, 제1항에 따른 권리
                    행사는 이용자의 법정대리인이나 위임을 받은 자 등 대리인을 통하여
                    하실 수 있습니다. 이 경우, 법정대리인은 이용자의 모든 권리를
                    가집니다.
                  </p>
                  <p>
                    <strong>5.</strong> 이용자는 정보통신망법, 개인정보보호법 등
                    관계법령을 위반하여 회사가 처리하고 있는 이용자 본인이나 타인의
                    개인정보 및 사생활을 침해하여서는 아니됩니다.
                  </p>
                </div>
              </section>

              <section className="privacy-section">
                <h2>제8조 (개인정보 자동수집장치의 설치, 운영에 대한 사항)</h2>
                <div className="privacy-subsection">
                  <p>
                    <strong>1.</strong> 회사는 제공하는 서비스를 통해 이용자의 정보를
                    저장하고 수시로 찾아내는 쿠키(cookie)를 설치하고 운용할 수도
                    있습니다. 회사가 쿠키(cookie)를 통해 수집한 고객의 정보는 다음의
                    목적을 위해 사용될 수 있습니다.
                  </p>
                  <div className="privacy-list-item">
                    <p>가. 리옵스에이아이 서비스 이용 시 회원별 차별화된 정보를 제공</p>
                    <p>
                      나. 회원과 비회원의 접속빈도 또는 머문 시간 등을 분석하여
                      이용자의 취향과 관심분야를 파악하여 특화된 서비스 제공
                    </p>
                    <p>다. 이용자의 사용 행태를 추적하여 개인화 서비스를 제공</p>
                    <p>라. 유료서비스를 이용할 때 이용기간 안내</p>
                    <p>마. 이용자들의 행동을 분석하여 서비스 개편 등의 척도로 활용</p>
                  </div>
                  <p>
                    <strong>2.</strong> 이용자는 쿠키 설치에 대해 거부할 수 있습니다.
                    단, 쿠키 설치를 거부하였을 경우 서비스를 정상적으로 이용하지 못 할
                    수 있습니다. 쿠키 설치 거부 방법은 다음과 같습니다.
                  </p>
                  <div className="privacy-warning-box">
                    <p>
                      <strong>쿠키 설치 거부 방법 (인터넷 익스플로러 기준):</strong><br />
                      웹 브라우저 상단의 도구 → 인터넷 옵션 → 개인정보 → 사이트 차단
                    </p>
                  </div>
                </div>
              </section>

              <section className="privacy-section">
                <h2>제9조 (개인정보의 파기)</h2>
                <div className="privacy-subsection">
                  <p>
                    <strong>1.</strong> 회사는 원칙적으로 개인정보 처리목적이 달성된
                    경우에는 지체없이 해당 개인정보를 파기합니다. 파기의 절차, 기한 및
                    방법은 다음과 같습니다.
                  </p>
                  <div className="privacy-info-box">
                    <h4>가. 파기절차</h4>
                    <p>
                      이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져(종이의
                      경우 별도의 서류) 내부 방침 및 기타 관련 법령에 따라 일정기간
                      저장된 후 혹은 즉시 파기됩니다. 이 때, DB로 옮겨진 개인정보는
                      법률에 의한 경우를 제외하고 다른 목적으로 이용되지 않습니다.
                    </p>
                    <h4>나. 파기기한</h4>
                    <p>
                      이용자의 개인정보는 개인정보의 보유기간이 경과된 경우에는
                      보유기간의 종료일로부터 5일 이내에, 개인정보의 처리 목적 달성,
                      해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게
                      되었을 때에는 개인정보의 처리가 불필요한 것으로 인정되는
                      날로부터 5일 이내에 그 개인정보를 파기합니다.
                    </p>
                  </div>
                  <p>
                    <strong>2.</strong> 회사는 정보통신망 이용촉진 및 정보보호 등에
                    관한 법률, 전자금융거래법 및 기타 관계법령에 따른 개인정보 보관
                    규칙을 성실하게 수행하고 있습니다.
                  </p>
                </div>
              </section>

              <section className="privacy-section">
                <h2>제10조 (개인정보의 안전성 확보)</h2>
                <p>
                  회사는 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한
                  기술적/관리적 및 물리적 조치를 하고 있습니다.
                </p>
                <div className="privacy-subsection">
                  <h3>1. 개인정보 취급 직원의 최소화 및 교육</h3>
                  <p>
                    개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화하여
                    개인정보를 관리하는 대책을 시행하고 있습니다.
                  </p>
                  <h3>2. 정기적인 자체 감사 실시</h3>
                  <p>
                    개인정보 취급 관련 안정성 확보를 위해 정기적(분기 1회)으로 자체
                    감사를 실시하고 있습니다.
                  </p>
                  <h3>3. 개인정보의 전송 및 관리</h3>
                  <p>
                    회사는 구글 등 <strong>외부 인증 연동(OAuth)</strong>을 통해 회원가입 및 로그인을 제공하므로 이용자의 비밀번호를 직접 수집하거나 저장하지 않습니다. 또한, 모든 구간에서 <strong>암호화 통신(HTTPS)</strong>을 적용하여 네트워크 상에서 개인정보가 안전하게 전송되도록 조치하고 있습니다.
                  </p>
                  <h3>4. 해킹 등에 대비한 기술적 대책</h3>
                  <p>
                    리옵스에이아이는 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및
                    훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신·점검을
                    하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고
                    기술적/물리적으로 감시 및 차단하고 있습니다. 특히 사용자 행동 분석 도구(Microsoft Clarity) 사용 시, 사용자가 입력하는 모든 민감 정보(텍스트, 숫자 등)는 '엄격한 마스킹(Strict Masking)' 기술을 적용하여 자동으로 가림 처리되며, 관리자를 포함한 누구도 원본 내용을 식별할 수 없도록 조치하고 있습니다.
                  </p>
                  <h3>5. 개인정보에 대한 접근 제한</h3>
                  <p>
                    개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여,
                    변경, 말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한
                    조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단
                    접근을 통제하고 있습니다.
                  </p>
                  <h3>6. 접속기록의 보관 및 위변조 방지</h3>
                  <p>
                    개인정보처리시스템에 접속한 기록을 최소 6개월 이상 보관, 관리하고
                    있으며, 접속 기록이 위변조 및 도난, 분실되지 않도록 보안기능
                    사용하고 있습니다.
                  </p>
                </div>
              </section>

              <section className="privacy-section">
                <h2>제11조 (개인정보 보호책임자 작성)</h2>
                <div className="privacy-subsection">
                  <p>
                    <strong>1.</strong> 회사는 개인정보 처리에 관한 업무를 총괄해서
                    책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제
                    등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
                  </p>
                  <div className="privacy-contact-info">
                    <h4>개인정보 보호책임자</h4>
                    <ul>
                      <li><strong>성명:</strong> 전성진</li>
                      <li><strong>직책:</strong> CEO</li>
                      <li><strong>직급:</strong> 대표이사</li>
                      <li>
                        <strong>이메일:</strong>
                        <a href="mailto:ReOpsAI@pxd.co.kr">ReOpsAI@pxd.co.kr</a>
                      </li>
                    </ul>
                  </div>
                  <p>
                    <strong>2.</strong> 정보주체께서는 회사의 서비스(또는 사업)를
                    이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리,
                    피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로
                    문의하실 수 있습니다. 회사는 정보주체의 문의에 대해 지체 없이 답변
                    및 처리해드릴 것입니다.
                  </p>
                </div>
              </section>

              <section className="privacy-section">
                <h2>제12조 (개인정보 처리방침 변경)</h2>
                <div className="privacy-subsection">
                  <p>
                    <strong>1.</strong> 회사는 이 개인정보 처리방침의 내용과 상호 및
                    대표자 성명, 영업소 소재지 주소, 전자우편주소, 사업자등록번호,
                    통신판매업 신고번호, 개인정보관리책임자 등을 연결화면을 통하여
                    게시합니다.
                  </p>
                  <p>
                    <strong>2.</strong> 회사는 회원가입 시 이용자에게 회원가입 행위가
                    개인정보 처리방침에 동의하는 행위임을 알리고 개인정보 처리방침의
                    내용을 연결화면을 통하여 볼 수 있도록 합니다.
                  </p>
                  <p>
                    <strong>3.</strong> 회사는 관련 법을 위배하지 않는 범위에서 이
                    개인정보 처리방침을 개정할 수 있습니다.
                  </p>
                  <p>
                    <strong>4.</strong> 회사가 개인정보 처리방침을 개정할 경우에는
                    개정사유를 명시하여 현행 개인정보 처리방침, 개정 개인정보
                    처리방침을 모두 볼 수 있도록 하여 서비스의 게시판에 개정 개인정보
                    처리방침 적용 7일 이전부터 적용일자 전일까지 공지하며 회원 각
                    개인의 이메일로 개정 개인정보 처리방침 적용 7일 이전에 개정 내용을
                    발송합니다.
                  </p>
                  <p>
                    <strong>5.</strong> 회사가 개인정보 처리방침을 개정할 경우에는
                    제1항에 의한 방법으로 회원들에게 개정 사항을 알리며 개정 개인정보
                    처리방침 적용 7일 이전부터 적용일자 전일까지 이의 의사를 회사측에
                    표명하지 않으면 개정 개인정보 처리방침에 동의하는 것으로
                    간주합니다.
                  </p>
                </div>
              </section>

              <section className="privacy-section">
                <h2>제13조 (권익침해 구제방법)</h2>
                <p>
                  개인정보주체는 개인정보침해로 인한 구제를 받기 위하여
                  개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에
                  분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보
                  침해의 신고 및 상담에 대하여는 아래의 기관에 문의하시기를 바랍니다.
                </p>
                <div className="privacy-contact-info">
                  <h4>개인정보 침해 신고 및 상담 기관</h4>
                  <ul>
                    <li><strong>개인분쟁조정위원회:</strong> (국번없이) 118</li>
                    <li>
                      <strong>정보보호마크인증위원회:</strong> 02-580-0533~4
                      <br /><small>웹사이트:
                        <a href="http://eprivacy.or.kr" target="_blank" rel="noopener noreferrer">http://eprivacy.or.kr</a></small>
                    </li>
                    <li>
                      <strong>대검찰청 사이버범죄수사단:</strong> 02-3480-3573
                      <br /><small>웹사이트:
                        <a href="http://www.spo.go.kr/" target="_blank" rel="noopener noreferrer">http://www.spo.go.kr/</a></small>
                    </li>
                    <li>
                      <strong>경찰청 사이버테러대응센터:</strong> 02-1566-0112
                      <br /><small>웹사이트:
                        <a href="https://www.cyber.go.kr/" target="_blank" rel="noopener noreferrer">https://www.cyber.go.kr/</a></small>
                    </li>
                  </ul>
                </div>
              </section>
            </div>

          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="privacy-footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <h3>ReOpsAI</h3>
            </div>
            <div className="footer-links">
              <Link to="/terms">이용약관</Link>
              <Link to="/privacy">개인정보/데이터처리방침</Link>
            </div>
            <div className="footer-copy">
              <p>ReOpsAI © 2025</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPolicyPage;

